
// Init
(function ( $ ) {
    $.ld_utilities = function ( duration ) {
	    
		$.ld_scroll_to( 200 );
		
    };
})( jQuery );



////////////////////////////////////////////////////////////////////////////////////////////////
// ld_scroll_top
////////////////////////////////////////////////////////////////////////////////////////////////
(function ( $ ) {
    $.ld_scroll_to = function ( duration ) {
	    
		$('a[href*="#"]:not([href="#"])').click(function() {
		  if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
		    var target = $(this.hash);
		    target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
		    if (target.length) {
		      $('html, body').animate({
		        scrollTop: target.offset().top
		      }, duration);
		      return false;
		    }
		  }
		});
		
    };
})( jQuery );